import { Pipe, PipeTransform } from '@angular/core';
import { IStrategyDisplay } from 'src/app/_interfaces/strategy/IStrategyDisplay';

@Pipe({
  name: 'strategyDisplay',
  standalone: false,
  pure: true
})
export class StrategyDisplayPipe implements PipeTransform {
  transform(strategy: Partial<IStrategyDisplay> | null | undefined): string {
    const firstLine = [
      this.getStrategyPart('DE', strategy?.strategyDirExt ?? strategy?.directExtinguishment),
      this.getStrategyPart('IC', strategy?.strategyIndirConf ?? strategy?.indirectConfinement)
    ].filter(Boolean);

    const secondLine = [
      this.getStrategyPart('F', strategy?.strategyFull ?? strategy?.fullSuppression),
      this.getStrategyPart('PZ', strategy?.strategyPointZone ?? strategy?.pointZoneProtection),
      this.getStrategyPart('C', strategy?.strategyConfine ?? strategy?.confine),
      this.getStrategyPart('M', strategy?.strategyMonitor ?? strategy?.monitor)
    ].filter(Boolean);

    if (!firstLine.length && !secondLine.length) {
      return 'N/A';
    }

    const lines: string[] = [];
    if (firstLine.length) {
      lines.push(firstLine.join(', '));
    }
    if (secondLine.length) {
      lines.push(secondLine.join(', '));
    }

    return lines.map((line) => `<div>${line}</div>`).join('');
  }

  private getStrategyPart(label: string, value: any): string {
    const numericValue = Number(value);
    if (value == null || Number.isNaN(numericValue) || numericValue === 0) {
      return '';
    }
    return `${label}:${numericValue}`;
  }
}
